import React from 'react';
import { Button, Loader } from '@thdinc/hpf-shared';
import deleteIcon from '@/assets/icons/deleteIcon.svg';
import eyeIcon from '@/assets/icons/quote_eye_icon.svg';

interface QuoteTemplateListProps {
    quoteTemplateList: any[];
    deletingQuoteId: string | null;
    onSelectTemplate: (quote: any) => void;
    onPreviewTemplate: (quote: any) => void;
    onDeleteTemplate: (quoteId: string) => void;
    onBlankProposal: () => void;
}

const QuoteTemplateList: React.FC<QuoteTemplateListProps> = ({
    quoteTemplateList,
    deletingQuoteId,
    onSelectTemplate,
    onPreviewTemplate,
    onDeleteTemplate,
    onBlankProposal,
}) => {
    return (
        <div className='flex flex-col gap-6 py-4'>
            <div className='flex flex-col gap-4'>
                {quoteTemplateList.map((data: any, index: number) => (
                    <div
                        key={index}
                        className='flex flex-row justify-between items-center px-5 gap-2 text-gray-700 text-sm truncate bg-gray-100 p-2 border border-gray-200 rounded-full cursor-pointer'
                    >
                        <div
                            onClick={() => onSelectTemplate(data)}
                            className='flex flex-row gap-6'
                        >
                            <span className='font-semibold text-gray-900 text-ellipsis'>
                                {`Template ${index + 1}`}:
                            </span>{' '}
                            {data?.template_title}
                        </div>
                        <div className='text-primary-red cursor-pointer'>
                            <div className='flex flex-row items-center gap-2'>
                                <div className='p-2 rounded-full bg-white'>
                                    {deletingQuoteId === data.id ? (
                                        <Loader color='bg-red-500' />
                                    ) : (
                                        <img
                                            onClick={() => onDeleteTemplate(data.id)}
                                            src={deleteIcon}
                                            alt='Delete Icon'
                                        />
                                    )}
                                </div>
                                <div className='p-1 rounded-full bg-white'>
                                    <img
                                        onClick={() => onPreviewTemplate(data)}
                                        src={eyeIcon}
                                        alt='View Icon'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className='flex justify-end'>
                <Button
                    className='bg-black text-white rounded-full py-3 w-[147px] text-sm sm:text-base font-medium text-nowrap'
                    onClick={onBlankProposal}
                >
                    Blank proposal
                </Button>
            </div>
        </div>
    );
};

export default QuoteTemplateList;
